// extracted by mini-css-extract-plugin
export default {"button-link":"button-link--3f0274","buttonLink":"button-link--3f0274"};